module.exports = "https://coursera_assets.s3.amazonaws.com/images/d62bf424793de088e2a09ff1ce4519ad.jpg";